import {Injectable} from '@angular/core';
import {Store} from '@ngxs/store';
import {Database, ref, get, onValue} from '@angular/fire/database';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@env';
import {lastValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MlService {
  headers: HttpHeaders;
  apiUrl: string;

  constructor(private store: Store, private db: Database, private http: HttpClient) {
    this.apiUrl = environment.apiUrl;
  }

  getUrl(url): string {
    return `${this.apiUrl}/${url}`;
  }

  getAllMakeAndModelData() {
    return lastValueFrom(this.http.post(this.getUrl('ml/data/vehicles/summary'), {}));
  }

  async getMlStats(callback): Promise<any> {
    const path = `carvryAI/mlStats`;
    const dbRef = ref(this.db, path);
    return onValue(dbRef, callback);
  }

  async getMlModelInfo(callback): Promise<any> {
    const path = `carvryAI/mlModelInfo`;
    const dbRef = ref(this.db, path);
    return onValue(dbRef, callback);
  }

  trainModel(data: any) {
    return lastValueFrom(this.http.post(this.getUrl('ml/train/train-ml-models'), data));
  }

  simulatePrice(data: any) {
    return lastValueFrom(this.http.post(this.getUrl('ml/simulate/simulate-price'), data));
  }

  createDataset(data: any) {
    return lastValueFrom(this.http.post(this.getUrl('ml/data/create-dataset'), data));
  }

  async getTrainingHistory(carMake: string, carModel: string, callback: any): Promise<any> {
    const path = `carvryAI/mlTraining/runLogs/carMakes/${carMake.toLowerCase()}/carModels/${carModel.toLowerCase()}`;
    const dbRef = ref(this.db, path);
    return onValue(dbRef, callback);
  }

  async getSimulationsByTimestamp(timestamp: string, callback: any): Promise<any> {
    const path = `carvryAI/mlSimulations/simulations/${timestamp}`;
    const dbRef = ref(this.db, path);
    return onValue(dbRef, callback);
  }

  async getAllSimulationsMetadata(callback: any): Promise<any> {
    const path = `carvryAI/mlSimulations/metadata`;
    const dbRef = ref(this.db, path);
    return onValue(dbRef, callback);
  }
}
